import React, { createContext, useCallback, useState } from 'react';

import { IFilterData, Filter } from './types';

export const FilterContext = createContext<IFilterData>({} as IFilterData);

const FilterProvider = ({ initialState = {}, children }) => {
  const [filter, setFilter] = useState<Filter>(initialState);
  const onChange = (value: Filter) =>
    setFilter(currentFilters => ({ ...currentFilters, ...value }));

  const onClear = useCallback(() => {
    setFilter(initialState);
  }, [initialState]);

  return (
    <FilterContext.Provider
      value={{
        filter,
        onChange,
        onClear,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export default FilterProvider;
